import Link from 'next/link'
import React from 'react'

function YourNextCareer() {
   return (
      <section className="culture_info">
         <div className="container container-xxl">
            <div className="text-center">
               <h2 className="section_heading_title mb-3">
                  Your Next Career Move Starts Here Join Us Now
               </h2>
               <p className="info_tell_description mb-4">
                  Discover interesting jobs at Benzatine Infotech where your
                  ambitions and skills can actually accelerate. Be part of a
                  group that appreciates development, innovation, and teamwork.
               </p>
               <Link
                  href="/discover-benzatine/career-overview#join-team"
                  className="btn-primary info_tell_btn"
               >
                  Find Career Opportunities
                  <svg
                     className="arrow-icon"
                     width="36"
                     height="19"
                     viewBox="0 0 36 19"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path d="M35.766 9.15325L27.5843 0.971548C27.2904 0.628359 26.7739 0.588352 26.4307 0.882323C26.0876 1.17622 26.0475 1.69273 26.3415 2.03592C26.369 2.06798 26.3987 2.09772 26.4307 2.12514L33.2133 8.91595H0.822048C0.370228 8.91595 0.00390625 9.28227 0.00390625 9.73416C0.00390625 10.186 0.370228 10.5523 0.822048 10.5523H33.2133L26.4307 17.3349C26.0876 17.6288 26.0475 18.1453 26.3415 18.4885C26.6355 18.8317 27.1519 18.8717 27.4951 18.5777C27.5272 18.5502 27.5569 18.5205 27.5843 18.4885L35.766 10.3068C36.0832 9.98777 36.0832 9.47239 35.766 9.15325Z" />
                  </svg>
               </Link>
            </div>
         </div>
      </section>
   )
}

export default YourNextCareer
